(() => {
  let activeGallery;
  let returnFocus;
  let cartSubscription;
  let cartRequest;
  function syncCartCount(event) {
    const counters = document.querySelectorAll('[data-pm3-cart-count]');
    if (!counters.length) return;
    const count = event?.cartData?.item_count;
    if (Number.isInteger(count)) {
      counters.forEach(counter => counter.textContent = count);
      return;
    }
    cartRequest?.abort();
    cartRequest = new AbortController();
    fetch(`${window.routes?.cart_url || '/cart'}.js`, { signal: cartRequest.signal })
      .then(response => { if (!response.ok) throw new Error('Cart update failed'); return response.json(); })
      .then(cart => { if (Number.isInteger(cart.item_count)) counters.forEach(counter => counter.textContent = cart.item_count); })
      .catch(() => {});
  }
  function init(root = document) {
    if (!cartSubscription && typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      cartSubscription = window.subscribe(PUB_SUB_EVENTS.cartUpdate, syncCartCount);
    }
    const lightbox = document.querySelector('[data-pm3-lightbox]');
    const closeZoom = () => {
      if (!lightbox?.open) return;
      lightbox.close();
    };
    const updateZoom = () => {
      const gallery = activeGallery;
      if (!gallery || !lightbox) return;
      const slide = gallery.slides[gallery.current];
      const picture = slide.matches('img') ? slide : slide.querySelector('img');
      const target = lightbox.querySelector('[data-pm3-enlarged]');
      target.src = picture.src;
      target.alt = picture.alt;
      const count = lightbox.querySelector('[data-pm3-zoom-count]');
      count.textContent = count.dataset.template.replace('[current]', gallery.current + 1).replace('[total]', gallery.slides.length);
      lightbox.querySelectorAll('[data-pm3-zoom-prev],[data-pm3-zoom-next]').forEach(button => button.hidden = gallery.slides.length < 2);
    };
    const openZoom = (gallery, opener) => {
      if (!lightbox || !gallery.slides.length) return;
      activeGallery = gallery;
      returnFocus = opener;
      updateZoom();
      if (!lightbox.open) {
        lightbox.dataset.scrollOverflow = document.documentElement.style.overflow;
        lightbox.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
    };
    const imageGallery = (images, current = 0) => ({
      slides: images,
      current,
      show(number) { this.current = (number + this.slides.length) % this.slides.length; }
    });
    if (lightbox && !lightbox.dataset.ready) {
      lightbox.dataset.ready = 'true';
      lightbox.querySelector('[data-pm3-close]').addEventListener('click', closeZoom);
      lightbox.querySelector('[data-pm3-zoom-prev]').addEventListener('click', () => { activeGallery.show(activeGallery.current - 1); updateZoom(); });
      lightbox.querySelector('[data-pm3-zoom-next]').addEventListener('click', () => { activeGallery.show(activeGallery.current + 1); updateZoom(); });
      lightbox.addEventListener('click', event => { if (event.target === lightbox) closeZoom(); });
      lightbox.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          activeGallery.show(activeGallery.current + (event.key === 'ArrowRight' ? 1 : -1));
          updateZoom();
        }
      });
      lightbox.addEventListener('close', () => {
        document.documentElement.style.overflow = lightbox.dataset.scrollOverflow || '';
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      });
      document.addEventListener('click', event => {
        const opener = event.target.closest('.product__modal-opener--image');
        const thumbnail = event.target.closest('media-gallery button.thumbnail');
        if (!opener && !thumbnail) return;
        const button = opener?.querySelector('button[data-media-id]') || thumbnail;
        const nativeGallery = thumbnail?.closest('media-gallery');
        const sectionId = nativeGallery?.closest('[data-section]')?.dataset.section;
        const modal = document.querySelector(opener?.dataset.modal || `#ProductModal-${sectionId}`);
        const mediaId = button?.dataset.mediaId || thumbnail?.closest('[data-target]')?.dataset.target.split('-').pop();
        const pictures = [...(modal?.querySelectorAll('img[data-media-id]') || [])];
        const index = pictures.findIndex(picture => picture.dataset.mediaId === mediaId);
        if (index < 0) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (nativeGallery?.setActiveMedia) nativeGallery.setActiveMedia(thumbnail.closest('[data-target]').dataset.target, false);
        openZoom(imageGallery(pictures, index), button);
      }, true);
    }
    root.querySelectorAll('media-gallery').forEach(element => {
      if (element.dataset.pm3Ready || !lightbox) return;
      element.dataset.pm3Ready = 'true';
      element.querySelectorAll('button.thumbnail').forEach(button => button.setAttribute('aria-haspopup', 'dialog'));
      const pictures = [...element.querySelectorAll('.product__modal-opener--image button[data-media-id]')];
      if (pictures.length < 2) return;
      const controls = document.createElement('div');
      controls.className = 'pm3-native-gallery-controls';
      for (const direction of [-1, 1]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = direction === -1 ? '←' : '→';
        button.setAttribute('aria-label', lightbox.querySelector(direction === -1 ? '[data-pm3-zoom-prev]' : '[data-pm3-zoom-next]').getAttribute('aria-label'));
        button.addEventListener('click', () => {
          const active = element.querySelector('.product__media-item.is-active');
          const current = pictures.findIndex(picture => active?.dataset.mediaId === `${element.closest('[data-section]').dataset.section}-${picture.dataset.mediaId}`);
          const next = (Math.max(current, 0) + direction + pictures.length) % pictures.length;
          const target = pictures[next].closest('.product__media-item');
          if (element.setActiveMedia && target) element.setActiveMedia(target.dataset.mediaId, false);
        });
        controls.appendChild(button);
      }
      element.appendChild(controls);
    });
    root.querySelectorAll('[data-pm3-gallery]').forEach(element => {
      if (element.dataset.ready) return;
      element.dataset.ready = 'true';
      const gallery = { element, slides: [...element.querySelectorAll('[data-pm3-slide]')], thumbs: [...element.querySelectorAll('[data-pm3-thumb]')], status: element.querySelector('[data-pm3-count]'), current: 0 };
      if (!gallery.slides.length) return;
      gallery.show = number => {
        gallery.current = (number + gallery.slides.length) % gallery.slides.length;
        gallery.slides.forEach((slide, index) => slide.hidden = index !== gallery.current);
        gallery.thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === gallery.current)));
        gallery.status.textContent = gallery.status.dataset.template.replace('[current]', gallery.current + 1).replace('[total]', gallery.slides.length);
      };
      element.querySelector('[data-pm3-prev]')?.addEventListener('click', () => gallery.show(gallery.current - 1));
      element.querySelector('[data-pm3-next]')?.addEventListener('click', () => gallery.show(gallery.current + 1));
      gallery.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => { gallery.show(index); openZoom(gallery, thumb); }));
      element.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); gallery.show(gallery.current + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      gallery.slides.forEach(slide => slide.addEventListener('click', () => openZoom(gallery, slide)));
      gallery.show(0);
    });
    root.querySelectorAll('[data-pm3-art-zoom]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const images = [button.querySelector('img'), ...button.closest('.pm3-showcase').querySelectorAll('[data-pm3-slide] img')];
        openZoom(imageGallery(images), button);
      });
    });
    root.querySelectorAll('.product__description img, .pm-description img').forEach(picture => {
      if (picture.closest('button,a') || !lightbox) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pm3-description-zoom';
      button.setAttribute('aria-label', lightbox.dataset.enlargeLabel);
      button.setAttribute('aria-haspopup', 'dialog');
      picture.replaceWith(button);
      button.appendChild(picture);
      button.addEventListener('click', () => {
        const pictures = [...button.closest('.product__description,.pm-description').querySelectorAll('img')];
        openZoom(imageGallery(pictures, pictures.indexOf(picture)), button);
      });
    });
    root.querySelectorAll('.pm3-purchase').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const variants = JSON.parse(form.querySelector('[data-pm3-variants]').textContent);
      const optionInputs = [...form.querySelectorAll('[data-pm3-option]')];
      const button = form.querySelector('[data-pm3-submit]');
      const id = form.querySelector('[data-pm3-variant-id]');
      const quantity = form.querySelector('[name=quantity]');
      function updateVariant() {
        const variant = optionInputs.length ? variants.find(v => v.options.every((value, index) => value === optionInputs[index].value)) : variants.find(v => String(v.id) === id.value);
        id.value = variant?.id || '';
        button.disabled = !variant?.available;
        button.textContent = variant?.available ? button.dataset.ready : button.dataset.sold;
        const price = form.parentElement.querySelector('[data-pm3-price]');
        if (variant && price && !price.querySelector('[data-pm6-current]')) price.textContent = variant.price;
        if (variant) {
          quantity.min = variant.min;
          quantity.step = variant.step;
          quantity.value = Math.max(Number(quantity.value) || variant.min, variant.min);
          if (variant.max) quantity.value = Math.min(Number(quantity.value), variant.max);
          if (variant.max) quantity.max = variant.max;
          else quantity.removeAttribute('max');
        }
      }
      optionInputs.forEach(input => input.addEventListener('change', updateVariant));
      const requiredInputs = [...form.querySelectorAll('[data-pm-required]')];
      const validateText = () => requiredInputs.forEach(input => input.setCustomValidity(input.value.trim() ? '' : input.dataset.pmRequired));
      requiredInputs.forEach(input => input.addEventListener('input', validateText));
      form.addEventListener('submit', event => {
        validateText();
        if (!form.reportValidity() || button.disabled || !id.value) event.preventDefault();
      });
      updateVariant();
    });
    root.querySelectorAll('.pm3-mobile-menu a').forEach(link => link.addEventListener('click', () => { const menu = link.closest('details'); menu.open = false; }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
